var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-migration-banner'),(_vm.showExtras)?_c('core-filter'):_vm._e(),(_vm.showExtras)?_c('core-toolbar'):_vm._e(),(_vm.showExtras)?_c('core-drawer'):_vm._e(),_c('core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }